export const CREATE_SHIFT= 'common@create-shift';
export const DELETE_SHIFT= 'common@delete-shift';
export const UPDATE_SHIFT= 'common@update-shift';